"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const List_1 = __importDefault(require("./List"));
const AddEdit_1 = __importDefault(require("./AddEdit"));
const AuthContext_1 = require("../../Auth/AuthContext");
const utils_1 = require("../../Auth/utils");
const Authors = ({ match }) => {
    const { path } = match;
    const { user } = (0, AuthContext_1.useAuth)();
    return ((0, utils_1.hasRole)(user, ['admin']) ? (react_1.default.createElement(react_router_dom_1.Switch, null,
        react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: path, component: List_1.default }),
        react_1.default.createElement(react_router_dom_1.Route, { path: `${path}/add`, component: AddEdit_1.default }),
        react_1.default.createElement(react_router_dom_1.Route, { path: `${path}/edit/:id`, component: AddEdit_1.default }))) : null);
};
exports.default = Authors;
